<template>
  <div class="content">
    <!--    <centerNav></centerNav>-->
    <div class="top">
      <div class="left">
        <div class="logo">
          <img alt="" src="@/assets/img/top_logo.png">
          <div class="logo-text">影票开放平台</div>
        </div>
      </div>
      <div v-if="$store.getters.nickname" v-popover:popover class="right">
        <img alt="" src="@/assets/img/top_header.png">
        <div class="right-text">{{ $store.getters.nickname }}</div>
        <img alt="" src="@/assets/img/top_icon_arrow_closed.png">
        <el-popover ref="popover" content="" placement="bottom" title="" trigger="click" width="100">
          <div class="out-login" @click="loginOut">
            退出
          </div>
        </el-popover>
      </div>
    </div>
    <div class="center">
      <div class="nav">
        <div :class="isActive == 0 ? 'active' : ''" class="nav-item" @click="select(0)">API订单</div>
        <div :class="isActive == 3 ? 'active' : ''" class="nav-item" @click="select(3)">淘宝询价人工纠错</div>
        <div :class="isActive == 1 ? 'active' : ''" class="nav-item" @click="select(1)">公众号订单</div>
        <div :class="isActive == 2 ? 'active' : ''" class="nav-item" @click="select(2)">小程序订单</div>
      </div>
      <div class="center-message">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import centerNav from "@/components/centerNav";

export default {
  name: "index",
  components: {
    centerNav
  },
  data() {
    return {
      isActive: 0
    }
  },
  mounted() {
    let index = localStorage.getItem('selectAccount')
    if (index) {
      this.isActive = index
      this.select(index)
    }
    // console.log("debug:________________this.$route.path______________", this.$route.path);
  },
  methods: {
    select(index) {
      this.isActive = index
      localStorage.setItem('selectAccount', index)
      if (index == 0) {
        this.$router.push({
          path: '/pc/bypassAccountOrder/ApiOrder',
        })
      }
      if (index == 1) {
        this.$router.push({
          path: '/pc/bypassAccountOrder/officialOrder',
        })
      }
      if (index == 2) {
        this.$router.push({
          path: '/pc/bypassAccountOrder/miniOrder',
        })
      }
      if (index == 3) {
        this.$router.push({
          path: '/pc/bypassAccountOrder/taobaoOrderError',
        })
      }
    },
    loginOut() {
      localStorage.removeItem('appKeyMini')
      localStorage.removeItem('appName')
      localStorage.removeItem('nowMini')
      localStorage.removeItem('isMerchant')
      localStorage.removeItem('selectAccount')
      localStorage.removeItem('openUserInfo')

      localStorage.removeItem("appKeyMiniZfb");
      this.$store.dispatch('user/logout')
      this.$Message.success('退出成功')
      this.$router.push({
        path: '/',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  background: #f5f5fa;

  .center {
    //background: #fff;
    display: flex;
    padding: 40px 60px;

    .nav {
      width: 220px;
      min-width: 220px;
      height: 960px;
      background: #FDFDFD;
      border-radius: 8px;

      .nav-item {
        padding: 14px 24px;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        cursor: pointer;
      }
    }

    .center-message {
      margin-left: 20px;
      padding: 20px;
      background: #fff;
      width: 80%;
    }
  }
}

.active {
  background: #FF8622 !important;
  color: #fff !important;
}

.top {
  background: #fff;
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;

  .right {
    display: flex;
    align-items: center;
  }

  .left {
    display: flex;
    align-items: center;

    .logo {
      display: flex;
      align-items: center;

      .logo-text {
        font-size: 18px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #333333;
        line-height: 25px;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/index.vue